var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isTopLevelRoute)?_c('PageTemplate',{attrs:{"title":_vm.$t('routeNames.Accreditation')}},[_c('v-row',{staticClass:"page-row",attrs:{"no-gutters":""}},[_c('GemaMemberSearch')],1)],1):_c('router-view')}
var staticRenderFns = []

export { render, staticRenderFns }